export enum Name {
    AUTH_TOKEN='isp_a_t',
    USER_EMAIL='isp_u_e',
    AUTH_TOKEN_API='authtoken',
    TESTER_TOKEN_API='testertoken',
    USER_INFO='isp_u_i',
}

export enum AuthScreenType {
    emailInput = "emailInput",
    agreement = "agreement",
    password = "password"
}

export enum DonutChartType {
  Type1 = 'Type1',
  Type2 = 'Type2'
}

export enum CreditDialogType {
  HISTORY = "HISTORY",
  REQUESTFORM = "REQUESTFORM"
}